import React, { Component } from 'react'
import $ from 'jquery'
import 'react-confirm-alert/src/react-confirm-alert.css'
import MultiselectTwoSides from "react-multiselect-two-sides";
import { Alert, Container, Row, Col, Button, Card, CardHeader } from "shards-react";
import { Redirect } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';


import {ApplicationsAPI,BusinessDBAPI} from '../../components/apis';
import Loading from '../../components/common/Loading';


class ApplicationBusiness extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      loading: true,
      goToApp: false,
      loadingApplication: true,
      alertVisible: true,
      businessdb: [],
      items: {},
      columns: {},
      apiActionErr: null,
      apiErr: null
    }
    this.api = new BusinessDBAPI(auth.getAccessToken(),this.props.idAccount);
  }

  _getBusinessdb() {
    var idAccount = this.props.idAccount;

    const token = auth.getAccessToken();
    const businessDBAPI = new BusinessDBAPI(token, idAccount);

    const self = this;

    businessDBAPI.getAll().then(businessdb => {

      var options = []
      var selectedItemIds = [];
      const appBusinessDBAPI = new BusinessDBAPI(token, idAccount);

        $.map(businessdb, function(bdb, index) {
            var item = {
                name: bdb.name,
                value: bdb.id
            }

          options.push(item);
        });

        appBusinessDBAPI.get(this.props.idAccount).then(dbsSelected => {

          $.map(dbsSelected, function(db, index) {
              selectedItemIds.push(db.db_id);
          });

          self.setState({
            loading: false,
            options: options,
            value: selectedItemIds,
            businessdb: businessdb,
            apiActionErr: null,
            apiErr: null
          })

        }).catch(err => {
          this.setState({
            loadingUsers: false,
            apiErr: err,
        })

    }).catch(err => {
      self.setState({
        loadingDB: false,
        apiErr: err,
      })
    });




    }).catch(function (error) {

      self.setState({
        loading: false,
        apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error
      })

    });

  }

  componentDidMount () {
    this._getBusinessdb();
    this._getApplication();
  }

  retry = () => {
    this.setState({
      alertVisible: true,
      apiErr: null,
      loading: true,
      businessdb: []
    }, () => this._getBusinessdb())
  }

  dismiss = () => {
    this.setState({ alertVisible: false });
  }

  _getApplication() {
    var id = this.props.idApp;
    const applicationsAPI = new ApplicationsAPI(auth.getAccessToken(), this.props.idAccount);
    const self = this;

    applicationsAPI.get(id).then(application => {
      self.setState({
        loadingApplication: false,
        application: application
      });
    }).catch(err => {
      self.setState({
        loadingApplication: false,
        apiErr: err
      })
    });
  }

  goBack = () => {
    history.goBack();
  }

  handleSubmit = (event) => {

    var selectedItemIds =  this.state.value;
    var self = this;
    var idApp = this.props.idApp;
    var idAccount = this.props.idAccount;

    const token = auth.getAccessToken()
    
    const appBusinessDBAPI = new BusinessDBAPI(token, idAccount);

    var cantItemsSelected = selectedItemIds.length;

    this.setState({
      loading: true
    })



    for (var i = 0; i < selectedItemIds.length; i++) {
        var id = selectedItemIds[i];

        const user = {
            "app_id" : idApp,
            "db_id" : id
        }

        appBusinessDBAPI.create(user).then(response => {

          cantItemsSelected--;

          if(cantItemsSelected === 0){
            self.setState({
               loading: false,
               goToApp: true
            })
          }

        }).catch(err => {
          this.setState({
            loading: false,
            apiErr: err,
          })
        });
    }

  }

  handleChange = (value) => {
    this.setState({value});
  }

  render () {
    const application = this.state.application
    const idApp = this.props.idApp;
    const idAccount = this.props.idAccount;

    // if(auth.isAuthenticated()){

        if (this.state.loading || this.state.loadingApplication) {
          return (
            // <div>
            //   <Container fluid>
            //     <br/>
            //     <div className="container center">
            //         <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
            //     </div>
            //   </Container>
            // </div>
            <Loading />  
          )
        }

        if (this.state.goToApp){
            return <Redirect to={"/accounts/"+idAccount+'/apps/'+idApp} />
        }

        if (this.state.apiErr) {
          return (
            <div>
              <Container fluid className="px-0">
                <Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}: {this.state.apiErr.message} </Alert>
              </Container>
                <Container fluid className="main-content-container px-4 pb-4">
                  <div className="error">
                    <div className="error__content">
                      <h2>500</h2>
                      <h3>{this.context.t('Something went wrong!')}</h3>
                      <p>{this.context.t('There was a problem on our end. Please try again later.')}</p>
                      <Button onClick={this.retry} pill><i className="material-icons">refresh</i> {this.context.t('Reload')}</Button>
                    </div>
                  </div>
                </Container>
            </div>
          )
        }



        let error
        if (this.state.apiActionErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiActionErr.message}</Alert></Container>
        }

        const {options, value} = this.state;
        const selectedCount = value.length;
        const availableCount = options.length - selectedCount;

        return (
          <div>

            {error}

            <Container fluid className="main-content-container px-4">

                <Row noGutters className="page-header py-4">
                    <PageTitle title={this.context.t('Applications')} subtitle={this.context.t('Add BusinessDB')} className="text-sm-left mb-3" />
                </Row>

                <br/>

              <Card small style={{ marginBottom: '20px'}}>
                <CardHeader className="border-bottom">
                  <h5 className="m-0">
                      <i className="material-icons blue-text md-24" style={{float: "left"}}>apps</i>
                      <span style={{float: "left", marginTop: "2px", marginLeft: "2px"}}>{application.name}</span>
                  </h5>

                  <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px"}}  onClick={e => {this.goBack()}}>arrow_back</i>

                </CardHeader>
                <div style={{ padding: "10px"}}>
                    <Row>
                        <Col lg="12">
                          <MultiselectTwoSides
                            {...this.state}
                            className="msts_theme_example"
                            onChange={this.handleChange}
                            availableHeader={this.context.t('Available')}
                            availableFooter={`Available: ${availableCount}`}
                            selectedHeader={this.context.t('Selected')}
                            selectedFooter={`Selected: ${selectedCount}`}
                            labelKey="name"
                            showControls
                            searchable
                          />
                        </Col>
                    </Row>

                    <hr/>

                    <Button theme="primary" outline className="mb-2 mr-1" onClick={e => this.handleSubmit(e)}>{this.context.t('Save')}</Button>
                    &nbsp;
                    <Button theme="secondary" outline className="mb-2 mr-1" onClick={this.goBack}>{this.context.t('Cancel')}</Button>
                </div>
              </Card>




            </Container>
            <br/>
            <br/>
          </div>

        )
    // }else{
    //     return <Redirect to='/' />
    // }

  }
}

ApplicationBusiness.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(ApplicationBusiness)
